<template>
  <div class="bs-wrapper no-power-box">
    <div class="content flex-col">
      <img
        :src="require('../../assets/img/common/noPower.png')"
        alt=""
        class="img"
      />
      <span>暂无权限，无法查看</span>
    </div>
  </div>
</template>

<script>
export default {
  name: '',

  mixins: [],

  components: {},

  props: {},

  data() {
    return {};
  },

  computed: {},

  watch: {},

  created() {},

  mounted() {},

  destroyed() {},

  methods: {},
};
</script>

<style lang="less" scoped>
.no-power-box {
  background: #fff;
}
.content {
  align-items: center;
  .img {
    margin-top: 62px;
    margin-bottom: 25px;
    width: 250px;
  }
  span {
    font-size: 13px;
    font-weight: 400;
    color: #999999;
  }
}
</style>
